// @flow
/* global window */

import { updateWidgetScroll } from './widgetMessaging';

type ScrollToOptions = {
  element?: ?HTMLElement,
  top?: number,
  offset?: number,
  behavior?: 'instant' | 'smooth' | 'auto',
};

/**
 * This will use the native `window.scroll` method to scroll to a particular offset or element.
 * This will also handle scrolling a widget into view on the host page, if applicable.
 */
export default function scrollTo({
  element,
  top = 0,
  offset = 0,
  behavior = 'smooth',
}: ScrollToOptions = {}) {
  if (typeof window === 'undefined') return;

  if (element != null) {
    top = element.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
  }
  top += offset;
  try {
    // Use options object, if supported, to get a smooth scroll
    window.scroll({ left: 0, top, behavior });
  } catch (error) {
    // otherwise fallback to setting the scroll position
    window.scroll(0, top);
  }
  updateWidgetScroll(window, 0);
}



// WEBPACK FOOTER //
// ./src/shared/utils/scrollTo.js